import { ref } from "vue"
import ComponentesService from "@/services/ComponentesService"

class ComponenteTextoService {
    setup({ respostas, respostaObrigatoria, etapaComponente, identificador, modulo, resumoModulos }) {
        const valorInformado = ref(respostas?.resposta || '');
        const statusResposta = ref('');

        if(!resumoModulos) {
            statusResposta.value = this.validarResposta(respostaObrigatoria, valorInformado.value);
            ComponentesService.salvarStatusComponente(etapaComponente, identificador, modulo, statusResposta.value);
        }

        return { valorInformado, statusResposta };
    }

    validarResposta(respostaObrigatoria, valorInformado) {



        const respondido = valorInformado != null && valorInformado != '';
            return ComponentesService.validaStatusRespostaComponente(respostaObrigatoria, respondido)
    }
}

export default new ComponenteTextoService();